/* global google */
import React, { useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';

// base function for creating DOM div node
function createOverlayElement() {
  const el = document.createElement('div');
  el.style.position = 'absolute';
  el.style.display = 'inline-block';
  el.style.width = '9999px';
  return el;
}

const OverlayContainer = (props) => {
  const overlay = useRef(null);
  const el = useRef(null);

  // modified OverlayView from google.maps [https://developers.google.com/maps/documentation/javascript/reference/3.44/overlay-view?hl=en]
  class OverlayView extends window.google.maps.OverlayView {
    constructor(props) {
      super();
      this.position = props.position || null;
      this.content = props.content || null;
    }

    onAdd = () => {
      if (this.content) this.getPanes().floatPane.appendChild(this.content);
    };

    onRemove = () => {
      if (this.content?.parentElement) {
        this.content.parentElement.removeChild(this.content);
      }
    };

    draw = () => {
      if (this.position) {
        const divPosition = this.getProjection().fromLatLngToDivPixel(this.position);
        this.content.style.left = `${divPosition.x}px`;
        this.content.style.top = `${divPosition.y}px`;
      }
    };
  }

  useEffect(() => {
    return () => {
      if (overlay.current) overlay.current.setMap(null);
    };
  }, []);

  if (props.map) {
    el.current = el.current || createOverlayElement();
    overlay.current = overlay.current || new OverlayView({
      position: new google.maps.LatLng(props.position.lat, props.position.lng),
      content: el.current,
    });
    overlay.current.setMap(props.map);
    return ReactDOM.createPortal(props.children, el.current);
  }
  return null;
}

export default OverlayContainer;
